<template>
  <div class="row">
    <div class="col-12">
      <ibox
        :title="this.$t('nav.training-regulations')"
        :collapseId="'collapse-2'"
      >
        <template slot="content" slot-scope="{ setLoading }">
          <TrainingRegulationsForm @loading="setLoading" />
        </template>
      </ibox>
    </div>
  </div>
</template>

<script>
import Ibox from "@/components/base/Ibox.vue";
import TrainingRegulationsForm from "@/components/Courses/TrainingRegulations.vue";

export default {
  name: "TrainingRegulationsDetails",
  components: {
    Ibox,
    TrainingRegulationsForm
  }
};
</script>
